<template>
  <div class="home__about" id="home__about">
    <div class="home__about--content">
      <h2>{{ $t("homeTranslate.homeAboutTitle") }}</h2>
      <p>{{ $t("homeTranslate.homeAboutBody") }}</p>
      <router-link to="/about" tag="a">{{ $t("homeTranslate.homeAboutRouterLink") }}</router-link>
    </div>
    <div class="home__about--holder">
      <div class="home__about--holder--block home__about--holder--block--1"></div>
      <div class="home__about--holder--image">
        <img src="https://notaireleveillee.s3.ca-central-1.amazonaws.com/assets/team3.JPG" alt="Notaire Montreal">
      </div>
      <div class="home__about--holder--block home__about--holder--block--2"></div>
      <div class="home__about--holder--block--3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-about',
  data () {
    return {
      locale: 'en'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
